/**
 * Campos e pesquisas prontas da tela de Pesquisa de Processos.
 *
 * A nomenclatura acompanha `PesquisaAvancadaProcesso.jsx` e
 * `PesquisaEspecialProcesso.jsx` do abe-web-react — no código real as
 * "pesquisas prontas" já existem com o nome "Pesquisas Especiais".
 */

/**
 * Campos da pesquisa, sempre visíveis, numa única grid de 2 colunas.
 * Ordem e coluna espelham o print de referência (`imagem (4).png`):
 * coluna 1 e coluna 2 lidas de cima para baixo, 9 linhas cada.
 * `paraODia` não aparece no print e foi removido.
 */
export const CAMPOS_PESQUISA = [
  // Coluna 1
  {
    id: 'nroProcesso', label: 'Processo:', tipo: 'texto', col: 1,
  },
  {
    id: 'cnpjCpfDevedor', label: 'CNPJ/CPF Devedor:', tipo: 'documento', col: 1,
  },
  {
    id: 'nomeDevedor', label: 'Nome devedor:', tipo: 'texto', col: 1,
  },
  {
    id: 'codigoCliente', label: 'Código do cliente:', tipo: 'texto', col: 1,
  },
  {
    id: 'nomeCliente', label: 'Nome Cliente:', tipo: 'texto', col: 1, largura: 'grande', maxLength: 40,
  },
  {
    id: 'negociador', label: 'Negociador:', tipo: 'select', col: 1, selectorKey: 'negociadores',
  },
  {
    id: 'status', label: 'Status:', tipo: 'select', col: 1, selectorKey: 'statusProcessos',
  },
  {
    id: 'agendamento', label: 'Agendamento:', tipo: 'select', col: 1, selectorKey: 'tiposAgendamentos',
  },
  {
    id: 'periodoEnvioFase', label: 'Período de envio para fase atual:', tipo: 'periodo', col: 1,
  },

  // Coluna 2
  {
    id: 'abertosEntre', label: 'Abertos entre:', tipo: 'periodo', col: 2,
  },
  {
    id: 'cidadeDevedor', label: 'Cidade do Devedor:', tipo: 'texto', col: 2,
  },
  {
    id: 'estadoDevedor', label: 'Estado do Devedor:', tipo: 'select', col: 2, selectorKey: 'estados',
  },
  {
    id: 'cpfCnpjCliente', label: 'CPF/CNPJ Cliente:', tipo: 'documento', col: 2,
  },
  // pasta: dependeDe 'fase' — desabilitado até uma Fase ser selecionada,
  // busca disparada no onChange da Fase (ver PesquisaProcessosPage.jsx).
  {
    id: 'pasta', label: 'Pasta:', tipo: 'select', col: 2, selectorKey: 'pastasDaFase', dependeDe: 'fase',
  },
  {
    id: 'recebidosEntre', label: 'Recebidos entre:', tipo: 'periodo', col: 2, dependeDe: 'negociador',
  },
  {
    id: 'fase', label: 'Fase:', tipo: 'select', col: 2, selectorKey: 'fases',
  },
  {
    id: 'dataAgendamento', label: 'Data do Agendamento:', tipo: 'data', col: 2,
  },
  {
    id: 'codigoDevedor', label: 'Código do Devedor:', tipo: 'texto', col: 2,
  },
];

/**
 * Pesquisas prontas. `params` descreve os campos condicionais que aparecem
 * quando o item é marcado.
 *
 * O conjunto de 8 itens espelha o print de referência (`imagem (4).png`) —
 * "Meus Processos" e "Processos de um Devedor Específico" não aparecem nele
 * e foram removidos. Ordem: `PesquisasProntas.jsx` renderiza este array num
 * único CSS Grid de 2 colunas sem `col` explícito (`grid-auto-flow: row`,
 * o default) — cada PAR consecutivo de itens forma uma linha (item par =
 * coluna esquerda, item ímpar = coluna direita), não "primeiro os da coluna
 * 1, depois os da coluna 2" (diferente de `CAMPOS_PESQUISA` acima, que usa
 * uma `Box` por coluna e por isso agrupa por `col`).
 */
export const PESQUISAS_PRONTAS = [
  {
    id: 'ultimaParcelaQuitada',
    label: 'Processos com a última parcela quitada no período',
    params: [{ id: 'periodo', label: 'Período', tipo: 'periodo' }],
  },
  {
    id: 'acordosVencidos',
    label: 'Processos com Acordos vencidos no período',
    params: [
      {
        id: 'negociador', label: 'Negociador', tipo: 'select', selectorKey: 'negociadores',
      },
      { id: 'periodo', label: 'Período', tipo: 'periodo' },
    ],
  },
  {
    id: 'naoTrabalhados',
    label: 'Processos não trabalhados',
    params: [
      {
        id: 'fase', label: 'Fase', tipo: 'select', selectorKey: 'fases',
      },
      {
        id: 'negociador', label: 'Negociador', tipo: 'select', selectorKey: 'negociadores',
      },
    ],
  },
  { id: 'minhasRequisicoes', label: 'Minhas Requisições', params: [] },
  { id: 'titulosNaoVencidos', label: 'Processos somente com Títulos não vencidos', params: [] },
  {
    id: 'expirados',
    label: 'Processos Expirados ou a Expirar',
    params: [{ id: 'codCliente', label: 'Cód. Cliente', tipo: 'texto' }],
  },
  { id: 'ajuizados', label: 'Processos Ajuizados', params: [] },
  {
    id: 'prazoNoPeriodo',
    label: 'Processos com Prazo em um período',
    params: [
      {
        id: 'tipoAgendamento', label: 'Tipo de Agendamento', tipo: 'select', selectorKey: 'tiposAgendamentos',
      },
      { id: 'periodoAgendamento', label: 'Período de Agendamento', tipo: 'periodo' },
    ],
  },
];
